import WalletContentsTable from "./WalletContentsTable";

export default WalletContentsTable;